import { CommonModule } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { PatrolRobloxExperience } from '../../../services/patrol-roblox-api.service';
import { PatrolRobloxCockpitService } from '../../../services/patrol-roblox-cockpit.service';
import { PatrolRobloxIngestPanelComponent } from '../patrol-roblox-ingest-panel/patrol-roblox-ingest-panel.component';

@Component({
  selector: 'app-patrol-roblox-universe-overview',
  standalone: true,
  imports: [CommonModule, TranslatePipe, PatrolRobloxIngestPanelComponent],
  templateUrl: './patrol-roblox-universe-overview.component.html',
  styleUrl: './patrol-roblox-universe-overview.component.scss',
})
export class PatrolRobloxUniverseOverviewComponent {
  #cockpit = inject(PatrolRobloxCockpitService);

  readonly experience = input.required<PatrolRobloxExperience>();

  formatDate(iso: string | undefined | null): string {
    return this.#cockpit.formatDate(iso);
  }
}
